import { createFileRoute } from "@tanstack/react-router"
import { MapLayout } from "src/layouts"

export const Route = createFileRoute("/_loggedIn/$organizationId/_map")({
	component: MapLayout,
})
